import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'fi',
    fullName: 'Finnish',
    nativeName: 'Suomi',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Jotain ihmeellistä on tulossa",
    landing_subtitle: "ArgVoid on sovellusten ja pelien kehitysstudio. Pysy kuulolla, uusia juttuja tulossa pian!",
    select_language: "Valitse Kieli",
    search_placeholder: "Hae kieliä...",
    terms_title: "Palveluehdot",
    policy_title: "Tietosuojakäytäntö",
    cookies_title: "Evästekäytäntö",
    terms_content: `
        <strong>1. Ehtojen hyväksyminen</strong><br>
        Nämä käyttöehdot hyväksytään käyttämällä ArgVoidia. Jos näitä ehtoja ei hyväksytä, palvelua ei tule käyttää.<br><br>

        <strong>2. Alustan käyttö</strong>X<br>
        ArgVoid ja sen sovellukset tarjotaan "sellaisenaan" tiedottamista ja luovia tarkoituksia varten. Palvelua saa käyttää vain laillisiin tarkoituksiin.<br>X<br>

        <strong>3. Kielletty toiminta</strong><br>
        Sivuston haavoittuvuuksien hyödyntäminen, roskapostin lähettäminen tai luvattoman pääsyn yrittäminen infrastruktuuriin on ehdottomasti kielletty.<br><br>

        <strong>4. Vastuuvapauslauseke</strong><br>
        Alustaa ja palveluita voidaan muuttaa milloin tahansa ilman erillistä ilmoitusta. Palvelun käytettävyydestä tai saatavuudesta ei anneta takuuta.
    `,
    policy_content: `
        <strong>1. Tietokokoelma</strong><br>
        Alusta ei vaadi käyttäjän todennusta tai tilin luomista tällä hetkellä. Kävijöiltä ei kerätä aktiivisesti henkilökohtaisia tunnistetietoja (kuten nimiä tai sähköpostiosoitteita).<br><br>

        <strong>2. Käyttötiedot</strong>X<br>
        Anonymisoitua perusanalytiikkaa voidaan kerätä sivuston liikenteen ymmärtämiseksi ja sovellusten parantamiseksi. Näitä tietoja ei ole linkitetty yksittäisiin käyttäjätunnuksiin.<br>X<br>

        <strong>3. Kolmannen osapuolen palvelut</strong><br>
        Kolmannen osapuolen palveluntarjoajia voidaan käyttää isännöinti- ja analytiikkapalveluihin. Näiden vastaavien palveluntarjoajien tietosuojakäytännöt säätelevät heidän infrastruktuurissaan käsiteltyjä anonyymejä tietoja.<br><br>

        <strong>4. Tietoturva</strong><br>
        Alustan suojaamiseksi toteutetaan kohtuulliset turvatoimenpiteet. Mikään Internetin kautta tapahtuva lähetystapa ei kuitenkaan ole täysin turvallinen.<br><br>
    `,
    cookies_content: `
        <strong>1. Mitä evästeet ja paikallinen tallennus ovat?</strong><br>
        Evästeet ja selaimen paikallinen tallennustila ovat pieniä datatiedostoja, jotka on tallennettu laitteelle, jotta ne muistavat määritysasetukset käyntien aikana.<br><br>

        <strong>2. Käyttötarkoitus</strong>X<br>
        Selaimen LocalStoragea käytetään vain konfigurointiasetusten tallentamiseen, kuten:<br>
        - Kieliasetukset<br>
        - Käyttöliittymän kokoonpano (esim. asettelun tai teeman asetukset) <br>
        - Väliaikainen sovellusvälimuisti<br><br>

        <strong>3. Ei seurantaa </strong><br>
        Evästeitä ja paikallista tallennustilaa ei käytetä mainontaan tai kolmannen osapuolen seurantatarkoituksiin. Kaikki tallennetut tiedot on tarkoitettu vain alustan ydintoimintoihin.<br><br>

        <strong>4. Control</strong><br>
        Selaimen tiedot voidaan tyhjentää milloin tahansa selaimen asetusten kautta, mikä nollaa kaikki paikalliset asetukset.
    `,
    cookie_consent_text: "Käytämme perusevästeitä varmistaaksemme, että verkkosivusto toimii oikein, kuten pitää istuntosi aktiivisena, tallentaa kieliasetuksesi ja muita mukautettuja määrityksiä.",
    read_policy: "Lue evästekäytäntö",
    support_title: "Ota yhteyttä tukeen",
    support_subject_label: "Aihe",
    support_message_label: "Viesti",
    support_submit_button: "Lähetä Viesti",
    support_hint: "Huomautus: Tämä avaa oletussähköpostisovelluksesi viestin lähettämistä varten.",
    support_success_msg: "Avataan sähköpostisovellusta...",
    support_error_msg: "Viestin lähettäminen epäonnistui. Yritä myöhemmin uudelleen.",
    explorer_title: "Tutkimusmatkailija",
    history_title: "Historia",
    animation_title: "Animaatio",
    config_title: "Kokoonpano",
    tool_mouse: "Valitse (Ctrl+M)",
    tool_brush: "Sivellin (Ctrl+B)",
    tool_brush_mode: "Vaihda tila (kiinteä/kirkas)",
    tool_eraser: "Pyyhekumi (Ctrl+E)",
    tool_brush_size: "Säädä harjan kokoa",
    tool_bucket: "Täytä (Ctrl+F)",
    tool_eyedropper: "Pipetti",
    tool_grid: "Ruudukko (Ctrl+Shift+B)",
    tool_rotate: "Kierrä (Ctrl+Shift+R)",
    tool_flip_h: "Käännä H (Ctrl+Shift+H)",
    tool_flip_v: "Käännä V (Ctrl+Shift+V)",
    tool_transpose: "Transponoi (Ctrl+Shift+T)",
    label_width: "Leveys",
    label_height: "Korkeus",
    label_frames: "Kehysten määrä",
    label_animation: "Animaatiotyyli",
    label_background_color: "Taustaväri",
    label_interval: "Intervalli",
    tool_anim_config: "Animaatioasetukset",
    label_new_width: "Uusi leveys",
    label_new_height: "Uusi korkeus",
    label_apply: "Käytä",
    label_colors: "värit",
    label_size: "Koko",
    label_tolerance: "Toleranssi",
    val_horizontal: "Vaakasuora",
    val_vertical: "Pystysuora",
    val_sequence: "Järjestys",
    val_bounce: "Pomppia",
    val_random: "Satunnainen",
    val_solid: "Kiinteä",
    val_clear: "Selkeä",
    action_add_sheet: "Uusi taulukko",
    action_import: "Tuoda",
    action_export: "Viedä",
    action_sort_projects: "Järjestellä",
    sort_date_old: "Vanhin ensin",
    sort_date_new: "Uusin ensin",
    sort_name_az: "Nimi (A-Z)",
    sort_name_za: "Nimi (Z-A)",
    action_new_sprite: "Uusi Sprite",
    action_new_project: "Uusi projekti",
    modal_save_all_title: "Tallenna kaikki muutokset",
    modal_save_all_desc: "Valitse tallennettavat resurssit:",
    modal_save_selected: "Tallenna valitut",
    action_saved: "Tallennettu",
    modal_create_sprite_title: "Luo uusi Sprite",
    modal_create_project_title: "Luo uusi projekti",
    modal_add_sheet_title: "Lisää uusi taulukko",
    modal_rename_sheet_title: "Nimeä taulukko uudelleen",
    modal_rename_sprite_title: "Nimeä Sprite uudelleen",
    modal_delete_sprite_title: "Poista Sprite",
    modal_delete_project_title: "Poista projekti",
    modal_delete_sheet_title: "Poista taulukko",
    placeholder_sprite_name: "Nimi",
    placeholder_project_name: "Nimi",
    placeholder_sheet_name: "Nimi",
    placeholder_new_name: "Uusi nimi",
    action_create: "Luoda",
    action_add: "Lisätä",
    action_rename: "Nimeä uudelleen",
    action_duplicate: "Kopioi",
    action_delete: "Poistaa",
    action_cancel: "Peruuttaa",
    confirm_delete_sprite: "Haluatko varmasti poistaa tämän spriten?",
    confirm_delete_project: "Haluatko varmasti poistaa tämän projektin? Kaikki spritet poistetaan.",
    confirm_delete_sheet: "Haluatko varmasti poistaa tämän taulukon?",
    err_select_sprite: "Valitse ensin sprite.",
    err_select_project: "Valitse ensin projekti.",
    err_name_empty: "Nimi ei voi olla tyhjä.",
    err_sprite_exists: "Tämän niminen sprite on jo olemassa.",
    err_project_exists: "Samanniminen projekti on jo olemassa.",
    err_no_content: "Ei tallennettavaa sisältöä.",
    err_no_changes: "Ei tallennettavia muutoksia.",
    err_delete_last_sheet: "Viimeistä arkkia ei voi poistaa.",
    err_extract_frames: "Kehyksiä ei voitu purkaa.",
    err_indexeddb: "Paikallinen tallennus epäonnistui. Selaimesi ei ehkä tue IndexedDB:tä.",
    msg_upload_success: "Lataus onnistui: {0}",
    msg_upload_failed: "Lataus epäonnistui: {0}",
    msg_save_success: "Tallennus onnistui.",
    msg_saving: "Tallennetaan...",
    msg_multi_save_result: "Tallennettu {0} omaisuutta. {1} virhettä.",
    menu_title: "Valikko",
    menu_save: "Tallentaa",
    menu_save_all: "Tallenna kaikki",
    menu_support: "Ota yhteyttä tukeen",
    label_local_storage: "Paikallinen tallennustila",
    label_sign_in: "Kirjaudu sisään",
    modal_export_title: "Vie Sprite",
    label_filename: "Tiedostonimi",
    label_format: "Muoto",
    action_export_confirm: "Viedä",
};

export default translations;
